import { PropsWithChildren } from 'react';
import { Heading } from '@/Components/UI/Heading';

type AccordionProps = PropsWithChildren<{
    title?: string;
}>

export const Accordion = ({ title, children }: AccordionProps) => {
    return (
        <>
            {title && (
                <Heading level={2} className={'mt-0'}>
                    {title}
                </Heading>
            )}

            <div>
                {children}
            </div>
        </>
    );
};
